import { ReactNode } from 'react'
import { Header } from './Header'

interface MainLayoutProps {
  children: ReactNode
  onAboutClick?: () => void
}

export function MainLayout({ children, onAboutClick }: MainLayoutProps) {
  return (
    <div className="min-h-screen bg-[var(--bg-primary)] flex flex-col" dir="rtl">
      <Header onAboutClick={onAboutClick} />
      <main className="flex-1 overflow-hidden">
        {children}
      </main>
    </div>
  )
}
